import { Box, Stack } from "@mui/material";
import { Allergies, Cuisines, NoGoes } from "assets/data";
import { Custom, Field, Workflow } from "components";
import { useApp, useTheme } from "contexts";
import { useWorkflow } from "contexts/components";
import { forwardRef } from "react";
import { StringOrOptionType } from "types";
import { createStep } from "utils/helpers";

const StepProfile = forwardRef(() => {
  const { updateData, data } = useWorkflow<Workflow.Utils.OnboardingType>(); // Get updateData from context
  const { theme } = useTheme();
  const { t } = useApp();

  return (
    <>
      <Custom.Typography size={theme.font.md} weight={theme.font.bold}>
        {t.component.workflow.onboarding.create_profile}
      </Custom.Typography>

      <Box mt={theme.spacing.md}>
        <Stack spacing={theme.spacing.sm}>
          <Custom.Typography size={theme.font.xs} weight={theme.font.bold}>
            {t.component.workflow.onboarding.onboarding_intro}
          </Custom.Typography>
          <Custom.Typography
            size={theme.font.xs}
            color={theme.color.font.accent}
          >
            {t.component.workflow.onboarding.form_message}
          </Custom.Typography>
        </Stack>
      </Box>

      <Box mt={theme.spacing.md}>
        <Stack spacing={theme.spacing.sm}>
          <Custom.Typography size={theme.font.xs} weight={theme.font.bold}>
            {t.component.workflow.onboarding.my_dietary_preference}
          </Custom.Typography>
          <Custom.TextField
            sx={{ mt: 0 }}
            placeholder={t.placeholder.enter_text}
            multiline
            rows={4}
            fullWidth
            value={data.user.dietary_preference || ""} // Bind to potluck context
            onChange={(e) =>
              updateData("user.dietary_preference", e.target.value)
            } // Update potluck state
          />
        </Stack>
      </Box>

      <Box mt={theme.spacing.md}>
        <Stack spacing={theme.spacing.sm}>
          <Custom.Typography size={theme.font.xs} weight={theme.font.bold}>
            {t.component.workflow.onboarding.my_allergy}
          </Custom.Typography>
          <Field.DynamicAutocomplete
            placeholder={t.placeholder.enter_text}
            options={Allergies}
            value={data.user.allergy || []}
            onChange={(values: StringOrOptionType[]) =>
              updateData("user.allergy", values as string[])
            } // Update potluck state
          />
        </Stack>
      </Box>

      <Box mt={theme.spacing.md}>
        <Stack spacing={theme.spacing.xs}>
          <Custom.Typography size={theme.font.xs} weight={theme.font.bold}>
            {t.component.workflow.onboarding.my_favorite}
          </Custom.Typography>
          <Field.DynamicAutocomplete
            freeSolo={false}
            label={t.component.workflow.onboarding.search}
            options={Cuisines}
            value={data.user.cuisines || []}
            onChange={(values: StringOrOptionType[]) =>
              updateData("user.cuisines", values as string[])
            } // Update potluck state
          />
        </Stack>
      </Box>

      <Box mt={theme.spacing.md}>
        <Stack spacing={theme.spacing.sm}>
          <Custom.Typography size={theme.font.xs} weight={theme.font.bold}>
            {t.component.workflow.onboarding.my_no_go}
          </Custom.Typography>
          <Field.DynamicAutocomplete
            placeholder={t.placeholder.enter_text}
            options={NoGoes}
            value={data.user.no_go || []}
            onChange={(values: StringOrOptionType[]) =>
              updateData("user.no_go", values as string[])
            } // Update potluck state
          />
        </Stack>
      </Box>
    </>
  );
});

export default createStep<Workflow.Utils.OnboardingType>(StepProfile);
